type Props = {
	title: string
	label?: string
	image?: boolean
	description?: string
	bullets?: (string | null)[] | null | undefined
}

export const SidebarGroup = ({ title, label, image, description, bullets }: Props) => {
	return (
		<div className="mb-10">
			<h2 className="text-bc-black font-medium pb-4 border-b border-b-gray-1000">{title}</h2>

			<h3 className="text-bc-black text-xs font-medium uppercase mt-4 mb-1">{label && label}</h3>

			{image && <div className="w-[86px] h-[28px] bg-gray-1000" />}

			<p className="text-gray-500 text-xs">{description && description}</p>

			<ul className="list-disc">
				{bullets &&
					bullets.map((bullet, i) => (
						<li key={i} className="text-gray-500 text-xs my-1 ml-4">
							{bullet}
						</li>
					))}
			</ul>
		</div>
	)
}
